import axios from 'axios';
import { API_END_POINT } from 'configs/configs';
import AuthUser from './auth';

class Appointments {
  /* send Request to the API endpoint
   *   return request promise
   */
  async sendRequest({ endpoint, params = {}, data = {}, method = 'GET' }) {
    try {
      let currentUserToken = AuthUser.getToken();
      let response = await axios({
        // Endpoint to send files
        url: endpoint,
        method: method,
        params,
        data,
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${currentUserToken}`,
        },
      });

      if (
        Number(response.data.error) !== 0 &&
        response.data.error !== undefined
      ) {
        return Promise.reject(response);
      }

      return Promise.resolve(response.data.results);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /*
   * Get all appointments of the current signedin user
   */
  async getAllAppointments(start_date, end_date) {
    return this.sendRequest({
      endpoint: `${API_END_POINT.APPOINTMENTS}`,
      params: {
        start_date,
        end_date,
      },
    });
  }

  /*
   * Get single appointment information referred by appointment_calendar_id
   */
  async getSingleAppointmentInformation(appointmentCalendarId) {
    if (isNaN(appointmentCalendarId)) {
      throw new Error(JSON.stringify({ error: 1, message: 'NOT_VALID_ID' }));
    }

    return this.sendRequest({
      endpoint: `${API_END_POINT.APPOINTMENTS}/${appointmentCalendarId}`,
    });
  }
  /*
   * Get all previous appointments information referred by start date
   */
  async getPreviousAppointment({ start_date, page = 1, limit = 10 }) {
    return this.sendRequest({
      endpoint: API_END_POINT.PREVIOUS_APPOINTMENT,
      params: {
        start_date,
        page,
        per_page: limit,
      },
    });
  }

  /*
   * Change exceptions days
   */
  async changeExceptionsDays({ start_date, end_date, exception_note,start_time,end_time,rrule,is_all_day,repeat_type,repeat_every,repeat }) {
    return this.sendRequest({
      endpoint: API_END_POINT.CHANGE_EXCEPTION_DAYS,
      data: {
        start_date,
        end_date,
        exception_note,
        start_time,
        end_time,
        rrule,
        is_all_day,
        repeat_type,
        repeat_every,
        repeat
      },
      method: 'POST',
    });
  }

  /*
   * Generate appointment calendar
   */
  async generateCalendar({
    start_date,
    end_date,
    start_time,
    end_time,
    time_period,
  }) {
  
    return this.sendRequest({
      endpoint: API_END_POINT.GENERATE_CALENDAR,
      data: {
        start_date,
        end_date,
        start_time,
        end_time,
        time_period,
      },
      method: 'POST',
    });
  }
  /*
   * Get exceptions 
   */
  async getExceptionDates() {
    return this.sendRequest({
      endpoint: API_END_POINT.EXCEPTIONS,
      method: 'GET',
    });
  }
  /*
   * Get Pateint report 
   */
    async getPatientReport(patientId) {
      return this.sendRequest({
        endpoint: `${API_END_POINT.PATIENTS}/${patientId}`,
        method: 'GET',
      });
    }
  /*
   * update appointment calendar exception id , by appointments
   */
  async updateAppointmentException({
   appointments,setExceptionId = null
  }) {
    return this.sendRequest({
      endpoint: API_END_POINT.EXCEPTIONS,
      data: {selected_appointments:appointments,exception_id:setExceptionId},
      method: 'PATCH',
    });
  }
  /*
   * update appointment calendar exception id , by appointments
   */
    async deleteAppointmentException(exceptionId) {
       return this.sendRequest({
         endpoint: API_END_POINT.EXCEPTIONS + '/' + exceptionId,   
         params:{},
         body:{app:1},
         method: 'DELETE',
       });
     }
}


Appointments = new Appointments();
export default Appointments;
